var _clipPath, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEuaFlag(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "none",
    height: 512,
    viewBox: "0 0 36 36",
    width: 512,
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _clipPath || (_clipPath = /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m0 0h36v36h-36z"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m18 36c9.9411 0 18-8.0589 18-18 0-9.94113-8.0589-18-18-18-9.94113 0-18 8.05887-18 18 0 9.9411 8.05887 18 18 18z",
    fill: "#f0f0f0"
  }), /*#__PURE__*/React.createElement("g", {
    fill: "#d80027"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m17.2177 17.9996h18.7825c0-1.6246-.2165-3.1985-.6201-4.6956h-18.1624z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m17.2177 8.60779h16.1406c-1.1019-1.79803-2.5107-3.38731-4.1534-4.69568h-11.9872z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m17.9998 35.9997c4.2363 0 8.13-1.4642 11.2047-3.913h-22.4094c3.07477 2.4488 6.9685 3.913 11.2047 3.913z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m2.64195 27.3895h30.71615c.8846-1.4434 1.5706-3.0212 2.0218-4.6957h-34.759783c.451193 1.6745 1.137233 3.2523 2.021833 4.6957z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "m8.33794 2.81095h1.64032l-1.52578 1.10848.58282 1.7936-1.52571-1.10848-1.52572 1.10848.50344-1.54948c-1.34339 1.11903-2.52084 2.43008-3.49115 3.89089h.52558l-.97122.70558c-.15132.25243-.29644.50885-.43552.76908l.46378 1.4274-.86526-.6286c-.21509.4556-.41182.9216-.58866 1.3973l.51096 1.5727h1.88592l-1.52578 1.1085.58282 1.7936-1.52571-1.1085-.913922.6641c-.0914761.7353-.139148 1.4843-.139148 2.2444h18c0-9.94106 0-11.11303 0-18-3.5558 0-6.8706 1.03148-9.66206 2.81095zm.69736 13.38905-1.52571-1.1085-1.52572 1.1085.58283-1.7936-1.52579-1.1085h1.88593l.58275-1.7936.58275 1.7936h1.88592l-1.52578 1.1085zm-.58282-7.03709.58282 1.79359-1.52571-1.10846-1.52572 1.10846.58283-1.79359-1.52579-1.10847h1.88593l.58275-1.7936.58275 1.7936h1.88592zm7.03932 7.03709-1.5257-1.1085-1.5257 1.1085.5828-1.7936-1.5258-1.1085h1.886l.5827-1.7936.5828 1.7936h1.8859l-1.5258 1.1085zm-.5828-7.03709.5828 1.79359-1.5257-1.10846-1.5257 1.10846.5828-1.79359-1.5258-1.10847h1.886l.5827-1.7936.5828 1.7936h1.8859zm0-5.24348.5828 1.7936-1.5257-1.10848-1.5257 1.10848.5828-1.7936-1.5258-1.10848h1.886l.5827-1.7936.5828 1.7936h1.8859z",
    fill: "#0052b4"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEuaFlag);
export default __webpack_public_path__ + "static/media/euaFlag.b0285bd0ab084011e7f0e79a3e9b9d4c.svg";
export { ForwardRef as ReactComponent };